import { Part } from "./part";
import { SampleVideo } from "./sample-video";
import * as Styled from "./style";
import { ProductInfo } from "~/components/blocks/product/common/blocks/product-tab-contents/product-info";
import { Review } from "~/components/blocks/product/common/blocks/product-tab-contents/review";
import { GRAVURE_SELECT_TABS } from "~/components/blocks/product/const";
import type { VideoLegacySeasonType } from "~/components/blocks/product/type-guard";

export type VideoLegacySeasonTabContentsProps = {
  videoLegacySeasonData: VideoLegacySeasonType;
  selectedTabValue: string;
};

/**
 * グラビア・VR | 作品末端のタブに紐づくコンテンツを表示するコンポーネント
 * - SEO的な都合上、Tab切り替えでコンテンツのマウント/アンマウントをするのは良くない
 * - なので、全てレンダリングした状態で表示/非表示を指定する
 * @param props {@link VideoLegacySeasonTabContentsProps}
 */
export const VideoLegacySeasonTabContents = (props: VideoLegacySeasonTabContentsProps) => {
  const { videoLegacySeasonData, selectedTabValue } = props;

  return (
    <Styled.DivContentsWrapper>
      <Styled.DivContentsBox isShow={selectedTabValue === GRAVURE_SELECT_TABS.PART}>
        <Part videoLegacySeasonData={videoLegacySeasonData} />
      </Styled.DivContentsBox>

      <Styled.DivContentsBox isShow={selectedTabValue === GRAVURE_SELECT_TABS.PRODUCT_INFO}>
        <ProductInfo videoData={videoLegacySeasonData} />
      </Styled.DivContentsBox>

      <Styled.DivContentsBox isShow={selectedTabValue === GRAVURE_SELECT_TABS.SAMPLE_VIDEO}>
        <SampleVideo videoLegacySeasonData={videoLegacySeasonData} />
      </Styled.DivContentsBox>

      <Styled.DivContentsBox isShow={selectedTabValue === GRAVURE_SELECT_TABS.REVIEW}>
        <Review videoData={videoLegacySeasonData} />
      </Styled.DivContentsBox>
    </Styled.DivContentsWrapper>
  );
};
